module.exports = __webpack_public_path__ + "img/shymkent4.8793f897.jpg";